import domready from "domready";
import "../vendor/clamp";
domready(function () {
  var reviewTexts = document.getElementsByClassName("review__text");
  if (reviewTexts !== null) {
    Array.prototype.forEach.call(reviewTexts, function (reviewText) {
      var cta = reviewText.querySelector(".review__cta");
      var review = reviewText.children[0];
      var reviewInfo = reviewText.querySelector(".review__item-info");
      if (review.offsetHeight < review.scrollHeight || reviewText.children[1] !== reviewInfo) {
        cta.innerHTML = cta.dataset.more;
        cta.style.display = "";
        cta.addEventListener("click", function (el) {
          ctaContent(cta, reviewText);
          reviewText.classList.toggle("review__text--short");
        });
      }
    });
  }
});
function ctaContent(cta, reviewText) {
  var review = reviewText.parentNode.parentNode;
  var reviewComment = review.querySelector(".review__comment");
  if (reviewText.classList.contains("review__text--short")) {
    cta.innerHTML = cta.dataset.less;
    if (reviewComment) {
      reviewComment.style.display = "";
    }
  } else {
    cta.innerHTML = cta.dataset.more;
    if (reviewComment) {
      reviewComment.style.display = "none";
    }
  }
}
